import { render, staticRenderFns } from "./discoverTwo.vue?vue&type=template&id=b2554cc6&"
import script from "./discoverTwo.vue?vue&type=script&lang=js&"
export * from "./discoverTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports